import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser, isPlatformServer } from '@angular/common';


const LOGGING_QUERY_PARAM = 'enableClientLogs'; // Name des Query-Parameters

@Injectable({
  providedIn: 'root'
})
export class LoggerService {
  private readonly isBrowser: boolean;
  private readonly isServer: boolean;
  private clientLoggingActive: boolean = false; // Standardmäßig deaktiviert

  constructor(@Inject(PLATFORM_ID) private platformId: object) {
    this.isBrowser = isPlatformBrowser(this.platformId);
    this.isServer = isPlatformServer(this.platformId);

    if (this.isBrowser) {
      this.initializeClientLoggingStateFromQueryParam();
    }
  }

  private initializeClientLoggingStateFromQueryParam(): void {
    const urlParams = new URLSearchParams(window.location.search);
    const queryParamValue = urlParams.get(LOGGING_QUERY_PARAM);

    // Logging ist aktiv, wenn der Query-Parameter 'true' ist.
    // In allen anderen Fällen (Parameter nicht vorhanden, anderer Wert) ist es deaktiviert.
    this.clientLoggingActive = queryParamValue === 'true';

    if (this.clientLoggingActive) {
      // Dieses erste Log hilft zu sehen, ob die Aktivierung per URL funktioniert hat.
      console.log(`[LoggerService] Client-side logging ENABLED via URL query parameter (${LOGGING_QUERY_PARAM}=true).`);
    }
  }

  /**
   * Prüft, ob das clientseitige Logging aktuell aktiv ist.
   * @returns true, wenn Logging aktiv ist, sonst false.
   */
  public isClientLoggingEnabled(): boolean {
    return this.isBrowser && this.clientLoggingActive;
  }

  log(message: any, ...optionalParams: any[]) {
    if (this.isBrowser && this.clientLoggingActive) {
      console.log(message, ...optionalParams);
    }
    // Server-Logging: Nur im Entwicklungsmodus
    // if (this.isServer) {
    //   console.log(`[SERVER]`, message, ...optionalParams);
    // }
  }

  warn(message: any, ...optionalParams: any[]) {
    if (this.isBrowser && this.clientLoggingActive) {
      console.warn(message, ...optionalParams);
    }
    // Server-Logging: Nur im Entwicklungsmodus
    // if (this.isServer) {
    //   console.warn(`[SERVER]`, message, ...optionalParams);
    // }
  }

  error(message: any, ...optionalParams: any[]) {
    // Client-Fehler: Loggen, wenn clientLoggingActive oder wenn in Produktion (um kritische Fehler immer zu sehen)
    if (this.isBrowser && (this.clientLoggingActive)) {
      console.error(`[BROWSER ERROR]`, message, ...optionalParams);
    }
    // Server-Fehler: Immer loggen
    if (this.isServer) {
      console.error(`[SERVER ERROR]`, message, ...optionalParams);
    }
  }

  group(label?: string) {
    if (this.isBrowser && this.clientLoggingActive) {
      console.group(label);
    }
    // if (this.isServer) {
    //   console.group(`[SERVER] ${label || ''}`);
    // }
  }

  groupCollapsed(label?: string) {
    if (this.isBrowser && this.clientLoggingActive) {
      console.groupCollapsed(label);
    }
    // if (this.isServer) {
    //   console.groupCollapsed(`[SERVER] ${label || ''}`);
    // }
  }

  groupEnd() {
    if (this.isBrowser && this.clientLoggingActive) {
      console.groupEnd();
    }
    // if (this.isServer && !environment.production) {
    // if (this.isServer) {
    //   console.groupEnd();
    // }
  }
}
